// extracted by mini-css-extract-plugin
export default {"container":"VPqHNYYn0_oTOtHukouK"};